export default "__VITE_ASSET__BWZvcXb4__"